import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React from 'react'
import { sendParameters } from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'

interface ExecutionWidgetProps {
  task: any
  isCanceled?: boolean
  initTask?: any
}

export default function ExecutionWidget({
  task,
  isCanceled,
  initTask
}: ExecutionWidgetProps) {
  const [startDate, setStartDate] = React.useState(dayjs())
  const [files, setFiles] = React.useState<any[]>([])
  const [isActUploaded, setIsActUploaded] = React.useState(
    task.meta?.isActUploaded || false
  )

  const [needsCalculation, setNeedsCalculation] = React.useState(
    task.meta?.needsCalculation || false
  )
  const [workType, setWorkType] = React.useState(task.meta?.workType || '')
  const [networkType, setNetworkType] = React.useState(
    task.meta?.networkType || ''
  )

  const showCalculationFields =
    initTask?.meta?.isEmergency || initTask?.meta?.isMunicipal

  const handleNeedsCalculationChange = (value: boolean) => {
    setNeedsCalculation(value)
    setFiles([])
  }

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      label="Исполняющий отдел"
      isCanceled={isCanceled}
      onSave={() => {
        sendParameters(
          task.paidServiceId,
          task.id,
          {
            startDate: startDate?.format('YYYY-MM-DD'),
            isActUploaded,
            ...(showCalculationFields
              ? { needsCalculation, workType, networkType }
              : {})
          },
          files
        )
      }}
    >
      <Stack direction="column" gap="1rem">
        {showCalculationFields && (
          <>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={!enabled}
                  value={needsCalculation}
                  checked={needsCalculation}
                  onChange={(e) =>
                    handleNeedsCalculationChange(e.target.checked)
                  }
                />
              }
              label="Требуется калькуляция"
            />
            <TextField
              disabled={!enabled}
              value={workType}
              onChange={(e) => setWorkType(e.target.value)}
              label="Вид работ"
            />
            <TextField
              disabled={!enabled}
              value={networkType}
              onChange={(e) => setNetworkType(e.target.value)}
              label="Параметры сети"
            />
          </>
        )}

        <FormControlLabel
          control={
            <Checkbox
              disabled={!enabled}
              checked={isActUploaded}
              onChange={(e) => setIsActUploaded(e.target.checked)}
            />
          }
          label="Акт загружен на стадии 'Определение'"
        />
        <Box display="flex" flexDirection="column">
          <Typography variant="subtitle1" color="black">
            Акты
          </Typography>
          {enabled ? (
            <FileUpload
              files={files}
              onUpload={(file: any) => setFiles([...files, file])}
              onDelete={(id: any) => setFiles(files.filter((file: any) => file.id !== id))}
            />
          ) : (
            <FileViewWidget files={task.files} />
          )}
        </Box>
        <Box display="flex" flexDirection="column">
          <Typography variant="subtitle1" color="black">
            Дата проведения работ:
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              disabled={!enabled}
              inputFormat="DD.MM.YYYY"
              value={startDate}
              onChange={(value) => value && setStartDate(value)}
              renderInput={(params) => <TextField required {...params} />}
            />
          </LocalizationProvider>
        </Box>
      </Stack>
    </TaskWrapper>
  )
}
